/** WS `alert_event` — đồng bộ GET /api/alerts/threshold-events. */
export interface GatewayAlertEventPayload {
  id: string;
  station_id?: string | null;
  stationId?: string | null;
  severity?: string;
  alert_type?: string;
}

/** WS `dashboard_kpi` — sau cảnh báo mới trên gateway. */
export interface GatewayDashboardKpiPayload {
  alertCount?: number;
  alerts?: { open?: number };
}

export function normalizeGatewayAlertEventPayload(raw: unknown): GatewayAlertEventPayload | null {
  if (raw == null || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const id = typeof o.id === 'string' ? o.id.trim() : '';
  if (!id) return null;
  const station_id =
    (typeof o.station_id === 'string' && o.station_id.trim()) ||
    (typeof o.stationId === 'string' && o.stationId.trim()) ||
    null;
  const severity = typeof o.severity === 'string' ? o.severity.trim() : undefined;
  const alert_type = typeof o.alert_type === 'string' ? o.alert_type.trim() : undefined;
  return { id, station_id, stationId: station_id, severity, alert_type };
}

export function normalizeGatewayDashboardKpiPayload(raw: unknown): GatewayDashboardKpiPayload | null {
  if (raw == null || typeof raw !== 'object') return null;
  const o = raw as Record<string, unknown>;
  const alertCount =
    typeof o.alertCount === 'number' && Number.isFinite(o.alertCount)
      ? o.alertCount
      : typeof o.alertCount === 'string' && o.alertCount.trim() !== ''
        ? Number(o.alertCount)
        : undefined;
  let alerts: GatewayDashboardKpiPayload['alerts'];
  if (o.alerts && typeof o.alerts === 'object' && !Array.isArray(o.alerts)) {
    const a = o.alerts as Record<string, unknown>;
    const open =
      typeof a.open === 'number' && Number.isFinite(a.open)
        ? a.open
        : typeof a.open === 'string' && a.open.trim() !== ''
          ? Number(a.open)
          : undefined;
    if (open !== undefined && !Number.isNaN(open)) alerts = { open };
  }
  if (alertCount === undefined && !alerts) return null;
  return {
    ...(alertCount !== undefined && !Number.isNaN(alertCount) ? { alertCount } : {}),
    ...(alerts ? { alerts } : {}),
  };
}
